import { WeatherConditionDictionary, WeatherDayType, WeatherForecastType } from "./weatherType";

const NO_FORECAST = {} as WeatherForecastType;
const NO_FORECASTS = [] as WeatherForecastType[];
const REFRESH_TIMEOUT_IN_MS: number = 1000 * 60 * 60 * 3;

const dict = {
    0: "błąd",
    1000: "Słonecznie",
    1003: "Częściowe zachmurzenie",
    1006: "Duże zachmurzenie",
    1009: "Pochmurno",
    1030: "Zamglenia",
    1063: "Możliwy przelotne opady deszczu",
    1066: "Możliwy przelotne opady śniegu",
    1069: "Możliwe przelotne opady mieszane",
    1072: "Możliwe przelotne opady marznące",
    1087: "Możliwe burze",
    1114: "Zamieć śnieżna",
    1117: "Blizzard",
    1135: "Mgła",
    1147: "Marznąca mgła",
    1150: "Przelotna mżawka",
    1153: "Opady mżawki",
    1168: "Opady marznącej mżawki",
    1171: "Opady marznącej mżawki",
    1180: "Lokalne opady słabego deszczu",
    1183: "Słabe opady deszczu",
    1186: "Przelotny deszcz",
    1189: "Deszcz",
    1192: "Przelotny, chwilami intensywny deszcz",
    1195: "Intensywny deszcz",
    1240: "Przelotne, słabe opady deszczu",
    1243: "Przelotny, chwilami intensywny deszcz",
    1246: "Ulewny deszcz",
    1273: "Możliwy przelotny deszcz oraz burze",
    1276: "Chwilami intensywe opady oraz możliwe burze"
} as WeatherConditionDictionary;


const translateToPL = (code: number, text: string): string => {
    return dict[code] ?? text;
}

const convert = (city: string, data: any): WeatherForecastType => {
    let forecast: WeatherForecastType = {
        lastDownload: window.Date.now(),
        city: city,
        days: []
    };

    if (Array.isArray(data.forecast.forecastday))
    {
        data.forecast.forecastday.forEach((f: any) => {
            forecast.days.push({
                date: f.date ?? "błąd",
                condition: translateToPL(f.day.condition.code ?? 0, f.day.condition.text ?? ""),
                maxtemp_c: Math.round(f.day.maxtemp_c ?? 0),
                mintemp_c: Math.round(f.day.mintemp_c ?? 0),
                maxwind_kph: Math.round(f.day.maxwind_kph ?? 0),
                totalprecip_mm: Math.round(f.day.totalprecip_mm ?? 0),
                uv: Math.round(f.day.uv ?? 0)
            } as WeatherDayType)
        });
    }

    return forecast;
}


export { convert, NO_FORECAST, NO_FORECASTS, REFRESH_TIMEOUT_IN_MS };